import { createSlice } from "@reduxjs/toolkit";

import { CompaniesState } from "@/types/companies";

import { RootState } from "@/redux";

import { Order } from "@/types/types";

import { companiesApi } from "./companies.api";

const initialState: CompaniesState = {
	companies: [],
	sortingCompanies: {
		sortBy: "createdAt",
		sortOrder: Order.ASC,
	},
	meta: {
		page: 1,
		limit: 15,
		itemCount: 15,
		pageCount: 1,
		hasPreviousPage: false,
		hasNextPage: false,
	},
};

export const companiesSlice = createSlice({
	name: "companies",
	initialState,
	reducers: {
		setCompaniesSorting: (state, { payload }) => {
			if (
				state.sortingCompanies.sortOrder === Order.DESC &&
				payload.sortOrder === Order.ASC &&
				payload.sortBy === state.sortingCompanies.sortBy
			) {
				payload.sortBy = initialState.sortingCompanies.sortBy;
				payload.sortOrder = initialState.sortingCompanies.sortOrder;
			}

			state.sortingCompanies = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(companiesApi.endpoints.getCompanies.matchFulfilled, (state, { payload }) => {
			if (!payload) {
				return;
			}

			if (payload.data) {
				state.companies = payload.data;
			}

			if (payload.meta) {
				state.meta = payload.meta;
			}
		});
	},
});

export const { setCompaniesSorting } = companiesSlice.actions;
export const companiesReducer = companiesSlice.reducer;
export const companiesSelector = (state: RootState) => state[companiesSlice.name];
